module.exports = __webpack_public_path__ + "img/bs.0b6a558a.jpg";